import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled } from '../../theme/utils.js';
import '../../theme/types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StyledFieldset = styled("fieldset", ({ $theme }) => ({
  marginTop: $theme.space[0],
  marginRight: $theme.space[0],
  marginBottom: $theme.space[0],
  marginLeft: $theme.space[0],
  paddingTop: $theme.space[0],
  paddingRight: $theme.space[0],
  paddingBottom: $theme.space[0],
  paddingLeft: $theme.space[0],
  borderStyle: "none"
}));
const StyledLegend = styled("legend", ({ $theme }) => __spreadProps(__spreadValues({
  display: "block",
  marginBottom: $theme.space[16],
  paddingTop: $theme.space[0],
  paddingRight: $theme.space[0],
  paddingBottom: $theme.space[0],
  paddingLeft: $theme.space[0],
  color: $theme.colors["text-brand-primary"]
}, $theme.typography.p3), {
  fontWeight: $theme.fontWeights.medium
}));

export { StyledFieldset, StyledLegend };
